/** 移动端设置分享到微信QQ的封面信息 */
import type { Data as RegistrationData } from '@quickService/ActivitiesPublicRegistrationPage';
import { setShareInfo } from '@tencent/calendar-web-component-mobile/es/Share/share-util';
import dayjs from 'dayjs';
import { useEffect } from 'react';

export const useShareInfo = (registrationData: RegistrationData) => {
  // 设置分享
  useEffect(() => {
    const { start_time: startTime = '', end_time: endTime = '' } =
      registrationData.activity_basic_info;
    let desc = '';
    if (startTime !== '' && endTime !== '') {
      const startDate = dayjs(Number(startTime) * 1000);
      const endDate = dayjs(Number(endTime) * 1000);
      const startFormat = startDate.format('YYYY/MM/DD HH:mm');
      const endFormat = endDate.format('YYYY/MM/DD HH:mm');
      desc = `活动时间：${startFormat} - ${endFormat}`;
      const now = dayjs();
      if (startDate.isAfter(now)) desc += '点击查看活动详情';
      if (startDate.isBefore(now) && endDate.isAfter(now)) desc += '\r\n活动进行中，尽快加入活动';
      if (endDate.isBefore(now)) desc = '活动已结束，点击查看详情或观看回放。';
    }
    setShareInfo(
      {
        shareUrl: window.location.href,
        title: registrationData?.activity_basic_info?.title || '腾讯会议·活动',
        desc,
        imageUrl: registrationData.activity_basic_info.background_urls[0] || '',
      },
      true,
    );
  }, [registrationData]);
};
